module.exports = __webpack_public_path__ + "img/home-3-891x535.75699550.png";